import { Location } from "./generated";

export * from "./generated";
export * from "./booking_preferences";
export * from "./quiz";
export * from "./common";

export function locationLink(loc: Location): URL {
  return new URL(`https://www.google.com/maps?q=${loc.lat},${loc.long}`);
}
